import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { languages, defaultLocale } from '@/assets/lang/I18n';

Vue.use(VueI18n);

const messages = Object.assign(languages);
const i18n = new VueI18n({
  locale: defaultLocale,
  messages,
  silentTranslationWarn: true,
});

/** Mantém o <html lang> igual ao idioma da pesquisa, para o leitor de tela usar a voz certa. */
export const applyDocumentLanguage = (): void => {
  document.documentElement.lang = i18n.locale;
};

export default i18n;
